import React, { useEffect, useState } from 'react';
import '../styles/Avatar.css';

// Correct image paths for our project structure - using the public folder
const neutralImagePath = '/avatar/neutral.jpg';
const happyImagePath = '/avatar/smiling.jpg';
const thinkingImagePath = '/avatar/thinking.jpg';
const surprisedImagePath = '/avatar/surprised.jpg';
const concernedImagePath = '/avatar/concerned.jpg'; // Reusing the thinking image for concerned expression
const encouragingImagePath = '/avatar/encouraging.jpg'; // New encouraging expression
const impressedImagePath = '/avatar/impressed.jpg';     // New impressed expression

const Avatar = ({ mood = 'neutral', speaking = false }) => {
  const [expression, setExpression] = useState(neutralImagePath);
  
  useEffect(() => {
    // Change expression based on the detected mood from conversation
    switch (mood) {
      case 'happy':
        setExpression(happyImagePath);
        break;
      case 'thinking':
        setExpression(thinkingImagePath);
        break;
      case 'concerned':
        setExpression(concernedImagePath);
        break;
      case 'surprised':
        setExpression(surprisedImagePath);
        break;
      case 'encouraging':
        setExpression(encouragingImagePath);
        break;
      case 'impressed':
        setExpression(impressedImagePath);
        break;
      default:
        setExpression(neutralImagePath);
    }
  }, [mood]);

  return (
    <div className={`avatar-container ${speaking ? 'speaking' : ''}`}>
      <div className="avatar-image">
        <img src={expression} alt={`Zach is ${mood}`} />
      </div>
      {speaking && <div className="speech-indicator"></div>}
    </div>
  );
};

export default Avatar; 